var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.getters.getIsLoggedIn)?_c('div',[_c('Navigation'),_c('Header')],1):_vm._e(),_c('v-main',{staticStyle:{"background-color":"var(--v-contentBackground-base)"}},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }